var map = {
	"./accounting.svg": "./src/assets/illustrations/setting/accounting.svg",
	"./available-banks.svg": "./src/assets/illustrations/setting/available-banks.svg",
	"./available-coins.svg": "./src/assets/illustrations/setting/available-coins.svg",
	"./coin-list.svg": "./src/assets/illustrations/setting/coin-list.svg",
	"./fixer.svg": "./src/assets/illustrations/setting/fixer.svg",
	"./otc.svg": "./src/assets/illustrations/setting/otc.svg",
	"./overall.svg": "./src/assets/illustrations/setting/overall.svg?db47",
	"./pairs.svg": "./src/assets/illustrations/setting/pairs.svg",
	"./remove-2fa.svg": "./src/assets/illustrations/setting/remove-2fa.svg?c7fa",
	"./robots.svg": "./src/assets/illustrations/setting/robots.svg",
	"./roles.svg": "./src/assets/illustrations/setting/roles.svg",
	"./staking.svg": "./src/assets/illustrations/setting/staking.svg",
	"./swap.svg": "./src/assets/illustrations/setting/swap.svg",
	"./tokens.svg": "./src/assets/illustrations/setting/tokens.svg",
	"./transfer-setting.svg": "./src/assets/illustrations/setting/transfer-setting.svg",
	"./user-accepted.svg": "./src/assets/illustrations/setting/user-accepted.svg?3761",
	"./user-levels.svg": "./src/assets/illustrations/setting/user-levels.svg",
	"./wages.svg": "./src/assets/illustrations/setting/wages.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/illustrations/setting sync recursive ^\\.\\/.*\\.svg$";